import { createFileRoute } from "@tanstack/react-router";

import { ProceduresPage } from "@/features/procedures/components/procedures-page";
import type { ProceduresSearch } from "@/features/procedures/lib/procedures-search";
import { proceduresSearchSchema, resetsPagination } from "@/features/procedures/lib/procedures-search";

export const Route = createFileRoute("/_authed/_dashboard/procedures/")({
  validateSearch: proceduresSearchSchema,
  component: ProceduresRoute,
});

function ProceduresRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProceduresPage
      search={search}
      onSearchChange={(patch) =>
        void navigate({
          // Only a patch that changes *which rows there are* sends you back to
          // page 1. Opening an affaire or the calendar leaves the list alone, so
          // it must keep the page you had paginated to.
          search: (prev: ProceduresSearch) => ({
            ...prev,
            ...(resetsPagination(patch) ? { page: undefined } : {}),
            ...patch,
          }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
